
import axios from "axios";

const API_URL = "/api/trainers";

// ==========================================
// SAVE TRAINER + RESUME
// ==========================================

export const saveTrainer = (multipartData) => {

    const token = localStorage.getItem("token");

    return axios.post(
        `${API_URL}/save`,
        multipartData,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
};


// ==========================================
// GET ALL TRAINERS
// ==========================================

export const getAllTrainer = () => {

    const token = localStorage.getItem("token");

    return axios.get(
        `${API_URL}/all`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
};

// ==========================================
// GET TRAINER BY ID (fetch from `trainers` table)
// ==========================================

export const getTrainerById = (id) => {

    const token = localStorage.getItem("token");

    return axios.get(
        `${API_URL}/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
};

// ==========================================
// GET TRAINER RESUME
// ==========================================


// Existing API: partner downloads
export const getTrainerResume = (id, partnerUserId) => {
  const token = localStorage.getItem("token");

  return axios.get(`${API_URL}/resume/${id}`, {
    params: { partnerUserId },
    headers: token
      ? { Authorization: `Bearer ${token}` }
      : {},
    responseType: "blob",
  });
};

// New API: trainer downloads their own resume


export const getOwnTrainerResume = (id) => {
  const user = JSON.parse(
    localStorage.getItem("user") || "{}"
  );

  if (!user.email) {
    throw new Error("Please log in again.");
  }

  return axios.get(
    `${API_URL}/${id}/resume-file`,
    {
      params: {
        email: user.email
      },
      responseType: "blob"
    }
  );
};



export const uploadOwnResume = (id, selectedFile) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (!user.email) {
    throw new Error("Please log in again.");
  }

  const formData = new FormData();
  formData.append("resume", selectedFile);

  return axios.put(
    `${API_URL}/${id}/resume-file`,
    formData,
    { params: { email: user.email } }
  );
};



// ==========================================
// DELETE TRAINER
// ==========================================

export const deleteTrainer = (id) => {

    const token = localStorage.getItem("token");

    return axios.delete(
        `${API_URL}/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
};


// ==========================================
// UPDATE TRAINER
// ==========================================

export const updateTrainer = (id, multipartData) => {

    const token = localStorage.getItem("token");

    return axios.put(
        `${API_URL}/${id}`,
        multipartData,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
};


// ==========================================
// UPDATE TRAINER STATUS
// ==========================================

export const updateTrainerStatus = (id, status) => {

    const token = localStorage.getItem("token");

    return axios.put(
        `${API_URL}/${id}/status`,
        {
            status: status
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }
    );
};
